export { default as default } from '../../modules/react/3x2'